<script setup lang="ts">
import { useTemplateRef } from 'vue';
import { useI18n } from '#imports';
import { useScriptTag } from '@vueuse/core';
import sfChatConfig from '@@/configuration/sf-chat.json';

const chatElement = useTemplateRef('chatElement');

declare global {
    interface Window {
        embeddedservice_bootstrap?: EmbeddedServiceBootstrap;
    }
}

interface EmbeddedServiceBootstrap {
    settings: {
        language?: string;
        devMode?: boolean;
        targetElement?: HTMLElement;
        useHostSiteLanguage?: boolean;
    };
    init: (_token: string, _chatId: string, _baseUrl: string, _opts: { scrt2URL: string }) => void;
}

interface LocaleConfig {
    baseUrl: string;
    token: string;
    chatId: string;
    scrt2URL: string;
    devMode: boolean;
}

const { locale } = useI18n();

const localeKey = locale.value as keyof typeof sfChatConfig;
const configByLocale: LocaleConfig | undefined = sfChatConfig[localeKey];

if (!configByLocale) {
    console.warn(`Unsupported locale: ${locale.value}!`);
} else {
    const [language] = locale.value.split('-');

    useScriptTag(
        `${configByLocale.baseUrl}/assets/js/bootstrap.min.js`,
        () => {
            try {
                const { embeddedservice_bootstrap } = window;
                if (embeddedservice_bootstrap) {
                    embeddedservice_bootstrap.settings.language = language;
                    embeddedservice_bootstrap.settings.useHostSiteLanguage = true;
                    embeddedservice_bootstrap.settings.devMode = configByLocale.devMode;
                    embeddedservice_bootstrap.settings.targetElement = chatElement.value ?? document.body;
                    embeddedservice_bootstrap.init(
                        configByLocale.token,
                        configByLocale.chatId,
                        configByLocale.baseUrl,
                        {
                            scrt2URL: configByLocale.scrt2URL,
                        },
                    );
                }
            } catch (err) {
                console.error('Error loading Embedded Messaging: ', err);
            }
        },
    );
}
</script>
<template>
    <div ref="chatElement" class="sf-live-chat"/>
</template>
<style lang="scss">
/* stylelint-disable declaration-no-important */
.embeddedMessagingConversationButtonWrapper {
    position: static !important;

    .embeddedMessagingConversationButton {
        position: static !important;
        width: 3.875rem !important;
        height: 3.875rem !important;
    }
}

.embeddedMessagingFrame {
    &.isMinimized {
        position: static !important;
    }
}

.embedded-messaging > .embeddedMessagingFrame {
    position: static !important;
}
/* stylelint-enable declaration-no-important */
</style>
